import { lazy, type FC, type ReactElement, Suspense } from 'react'

import { Loader } from '../components/Loader'

const LazyPasskeyManagementPage = lazy(() =>
  import('../pages/PasskeyManagement/PasskeyManagementPage').then((module) => ({
    default: module.PasskeyManagementPage,
  })),
)

export const PasskeyManagementRoute: FC = (): ReactElement => {
  return (
    <Suspense fallback={<Loader />}>
      <LazyPasskeyManagementPage />
    </Suspense>
  )
}
